exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-btn[data-v-0320067c]{border:1px solid;border-radius:50%;padding:12px 18px;font-size:18px}@media (max-width: 767px){.cms_content[data-v-0320067c] .kontakt-border{border-right:0px solid black;padding-right:0px}}@media (max-width: 767px){.cms_content[data-v-0320067c] .kontakt-text-box{padding-left:0px}}.breadcrumbs[data-v-0320067c]{padding-top:30px;-ms-flex-pack:center;justify-content:center}.breadcrumbs[data-v-0320067c] .opacity-breadcrubms{color:white}#wordpress-page[data-v-0320067c]{max-height:calc(100vh - 128px)}@media (max-width: 1024px){#wordpress-page[data-v-0320067c]{max-height:calc(100vh - 62px)}}\n", ""]);

// exports
